import type React from 'react'
import { createContext, useContext } from 'react'

export type PortalContextValues = HTMLDivElement | null

export const PortalContext = createContext<PortalContextValues>(null)

export const PortalProvider =
  PortalContext.Provider as React.Provider<PortalContextValues>

export const usePortal = () => useContext(PortalContext)
